import { GAME_ID, REDUX_ACTIONS } from 'a/cutItOut/data/constants';

export const initialState = {
  highlightedPictureLabel: null,
  instructionIsPlaying: false,
};

const instructionReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND: {
      return initialState;
    }
    case REDUX_ACTIONS.SET_HIGHLIGHTED_PICTURE:
      return {
        ...state,
        highlightedPictureLabel: action.payload.highlightedPictureLabel,
      };
    case REDUX_ACTIONS.SET_INSTRUCTION_PLAYING:
      return {
        ...state,
        instructionIsPlaying: action.payload.instructionIsPlaying,
      };
    default:
      return state;
  }
};

export default instructionReducer;
